import { render, staticRenderFns } from "./CustomersModal.vue?vue&type=template&id=366f0597&"
import script from "./CustomersModal.vue?vue&type=script&lang=js&"
export * from "./CustomersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports